<template>
	<div class="set-has-keywords">
		<div class="set-has-keywords__tools" v-show="step == 'table'">
			<el-row :gutter="20">
				<el-col :span="14">
					<el-input placeholder="搜索关键词 / 规则名称" v-model="searchVal" clearable
						prefix-icon="el-icon-search" size="mini"></el-input>
				</el-col>
				<el-col :span="10">
					<el-button class="search-btn" size="mini" @click="getList()">查 询</el-button>
					<el-button type="primary" size="mini">重 置</el-button>
					<el-button type="primary" size="mini" plain icon="el-icon-plus" @click="onAdd">添 加</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="set-has-keywords__table" v-show="step == 'table'">
			<table-pagination v-loading="loading" ref="tableItem" pagination layout="prev,pager,next,total" :data="data"
				:column="column" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
				@pagination="getList">
				<template v-slot:expand="{row}">
					<ul class="expand-lists">
						<li>
							<span>关键词：</span>
							<span class="el-tag-customer" v-for="(keyword,index) in row.rulesKeyList" :key="index">{{keyword.keysValue}}</span>
						</li>
						<li>
							<span>回复内容：</span>
							<span class="el-tag-customer" :class="{'red':keyword.responseType == 'im'}" v-for="(keyword,index) in row.rulesResponseList" :key="index">
									{{keyword.responseType == 'text' ? '文本': 'IM'}} : {{keyword.response}}
							</span>
						</li>
					</ul>
				</template>
				<template v-slot:action="{row}">
					<div class="operate-inline">
						<el-button type="text" size="small" @click="onEdit(row)">编辑</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-popconfirm title="确定要删除规则吗？" icon="el-icon-info" @confirm="onDelete(row)">
						   <el-button slot="reference" type="text" size="small">删除</el-button>
						</el-popconfirm>
					</div>
				</template>
			</table-pagination>
		</div>
		<!-- 新增以及编辑 -->
		<setHasKeywordsItem v-if="step=='operate'" @onBack="onBack" :row_subs="row_subs" @getList="getList"></setHasKeywordsItem>
	</div>
</template>

<script>
	import setHasKeywordsItem from './setHasKeywordsItem'
	export default {
		components: {
			setHasKeywordsItem
		},
		props:['row_item'],
		watch:{
			row_item(val){
				this.listQuery.pageNum = 1
				this.getList();
			}
		},
		data() {
			return {
				loading: false,
				data: [],
				total: 0,
				column: [{
						label: '更多',
						prop: 'expand',
						type: 'expand',
						slotScope: true
					},
					{
						label: '规则名称',
						prop: 'rulename',
					},
					{
						label: '关键词',
						prop: 'rulesKeyList',
						render:(h,scope)=> {
							return <span>{this.formatValue(scope.row.rulesKeyList,'keysValue')}</span>
						}
						
					},
					{
						label: '回复内容',
						prop: 'rulesResponseList',
						render:(h,scope)=> {
							return <span>{this.formatValue(scope.row.rulesResponseList,'response')}</span>
						}
					},
					{
						label: "操作",
						prop: "action",
						align: "center",
						width: 120,
						fixed:'right',
						slotScope: true,
					}
				],
				listQuery: {
					pageNum: 1,
					pageSize: 10
				},
				step:'table',
				searchVal:''
			}
		},
		methods: {
			getList(val) {
				if(val){
					this.listQuery.pageNum = val
				}
				this.step = 'table'
				let params = {
					 data: {
					    appid: this.row_item.appid || this.row_item.id,
					    searchvalue: this.searchVal
					  },
					  pageNum: this.listQuery.pageNum,
					  pageSize: this.listQuery.pageSize,
				}
				this.$api.getWechatSystemkeywordsRules(params).then(res => {
					if(res.errcode == 0) {
						this.data = res.list;
						this.total = res.total
						
					}
				})
			},
			onEdit(row) {
				this.step = 'operate';
				this.row_subs = row
			},
			onDelete(row) {
				this.$api.deleteWechatSystemkeyword({id:row.id}).then(res => {
					if(res.errcode == 0) {
						this.$message.success("删除成功");
						this.getList()
					}
				})
			},
			onAdd(){
				this.step = 'operate'
				this.row_subs = ''
			},
			onBack(){
				this.step = 'table'
			},
			formatValue(data,type){
				let results = [];
				if(data){
					data.map(item => {
						results.push(item[type])
					})
				}
				return results.join(',')
			}
		},
		async mounted() {
			await this.getList();
		}
	}
</script>

<style lang="scss">
	.set-has-keywords {
		.search-btn {
			color: #337EFF;
			border: 1px solid #337EFF;
		}

		&__table {
			margin-top: 20px;

			.el-table__expanded-cell[class*=cell] {
				padding: 10px 50px;
			}

			.expand-lists {
				width: 100%;
				li {
					list-style: none;
					font-size: 12px;
					margin: 5px 0;
					width: 100%;
					

					>span {
						font-weight: bold;
						margin: 3px;
					}
					.el-tag-customer {
						display: inline-block;
						max-width: 100%;
						word-wrap:break-word; 
						word-break:break-all; 
						background-color: #e8f4ff;
						border: 1px solid #d1e9ff;
						color: #1890ff;
						border-radius:4px;
						padding: 2px 5px;
						&.red {
							background-color: #fef0f0;
							border-color: #fde2e2;
							color: #f56c6c;
						}
					}
				}
			}
		}
	}
</style>
